export enum ENTITIES {
  GET_USERS = "users/get-users",
  GET_TIERS = "tiers/get-all-tiers",
  GET_RULES = "points-rules/get-all-rules",
  ADD_RULES = "points-rules/add-rule",
  GET_USER_POINTS = "points/get-user-points-details",

  LOG_IN = "auth/login",
  GET_ALL_FAMILIES = "families/get-all-families",
  GET_FAMILY = "families/get-family",
  CREATE_FAMILY = "families/create-family",
  UPDATE_FAMILY = "families/update-family",
  DELETE_FAMILY = "families/delete-family",
}
